import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./index.css";
// import coreValuesImg from "../assests/aboutImages/coreValues.png";

// Overview Images
import overviewImg from "../assests/aboutImages/overView-2.png";
//miniLogo
import minLogo from "../assests/aboutImages/images.svg";
import visionImg from "../assests/aboutImages/Ourvision.svg";
import missionImg from "../assests/aboutImages/ourMission.svg";

// Key facts icons
import marketCapImg from "../assests/aboutImages/marketcap.svg";
import countriesImg from "../assests/aboutImages/countries.svg";
import employeesImg from "../assests/aboutImages/employees.svg";
import scientistsImg from "../assests/aboutImages/scientist.svg";

// Arrow Icons
import arrows from "../assests/aboutImages/arrow.svg";

// Info Grid icons
import innovationImg from "../assests/aboutImages/innovation.svg";
import qualityImg from "../assests/aboutImages/quality.svg";
import growthImg from "../assests/aboutImages/global.svg";

// Human Health Icons
import humanFlagImg from "../assests/aboutImages/humanflag.svg";
import humanBuildingImg from "../assests/aboutImages/humanbuilding.svg";
import humanGlobeImg from "../assests/aboutImages/humanworld.svg";
import humanArrowImg from "../assests/aboutImages/humangrow.svg";
import humanCircleImg from "../assests/aboutImages/humancircle.svg";
import humanRocketImg from "../assests/aboutImages/humanrocket.svg";

// Animal Health Icons
import animalFlagImg from "../assests/aboutImages/animalflag.svg";
import animalBuildingImg from "../assests/aboutImages/animalbuilding.svg";
import animalGlobeImg from "../assests/aboutImages/animalworld.svg";
import animalArrowImg from "../assests/aboutImages/animalgrow.svg";
import animalCircleImg from "../assests/aboutImages/animalcircle.svg";
import animalRocketImg from "../assests/aboutImages/animalrocket.svg";

// Strategy Icons
import strategyImg from "../assests/aboutImages/strategy.svg";
import operationalImg from "../assests/aboutImages/operational.svg";
import talentImg from "../assests/aboutImages/talent.svg";

// Governance & Ethics Main Icons
import mainGovernanceImg from "../assests/aboutImages/mainCoroporate.svg";
import mainEthicsImg from "../assests/aboutImages/mainethics.svg";


// Leadership Images
import kamalImg from "../assests/aboutImages/kamal.png";
import haribabuImg from "../assests/aboutImages/haribabu.svg";
import rajaramImg from "../assests/aboutImages/rajaram.png";
import anujImg from "../assests/aboutImages/anuj.png";
import fabianImg from "../assests/aboutImages/Fabin.svg";
import greogoryImg from "../assests/aboutImages/gregory.svg";
import milindImg from "../assests/aboutImages/milind.svg";
import revatiImg from "../assests/aboutImages/revathi.png";
import executiveD from "../assests/aboutImages/executiveD.png";
import kiranImg from "../assests/aboutImages/kiran-img.png";
import ramakantImg from "../assests/aboutImages/ramakant-img.png";
import samsonImg from "../assests/aboutImages/samson-img.png";
import rajkamalImg from "../assests/aboutImages/mr-rajkamal-varshney-photo.png";
import Alexis from "../assests/aboutImages/Alexis.png";
import srinivasImg from "../assests/aboutImages/srinivas-img.png";
import janakiImg from "../assests/aboutImages/janaki.png";
import aj from "../assests/aboutImages/aj-reddy-img.png";
import pramodImg from "../assests/aboutImages/dr-pramod-kumar.png";
import YawarAbbas from "../assests/aboutImages/Yawar-Abbas.png";
import MuratMentes from "../assests/aboutImages/Murat-Mentes.png";
import RamonVila from "../assests/aboutImages/Ramon-Vila.png";
import MrPrasadLad from "../assests/aboutImages/Mr-Prasad-Lad.png";
import vasi from "../assests/aboutImages/srinivas-img-1.png";
import Alan from "../assests/aboutImages/Alan.png";

// Governance and Ethics Icons
import corp1 from "../assests/aboutImages/Corporate-1.svg";
import corp2 from "../assests/aboutImages/Corporate-2.svg";
import corp3 from "../assests/aboutImages/Corporate-3.svg";
import corp4 from "../assests/aboutImages/Corporate-4.svg";
import ethics1 from "../assests/aboutImages/Ethics-1.svg";
import ethics2 from "../assests/aboutImages/Ethics-2.svg";
import ethics3 from "../assests/aboutImages/Ethics-3.svg";
import ethics4 from "../assests/aboutImages/Ethics-4.svg";

//images Desktop
import desktopImg from "../assests/aboutImages/desktop.jpeg";
import mobileImg from "../assests/aboutImages/mobile.png";

// Business Update & Merger Notices PDFs
import BU_Q3_25_26 from '../assests/aboutImages/BusinessUpdate/Q3 FY 2025-26.pdf';
import BU_Q2_25_26 from '../assests/aboutImages/BusinessUpdate/Q2 FY 2025-26.pdf';
import BU_Q1_25_26 from '../assests/aboutImages/BusinessUpdate/Q1 FY 2025-26.pdf';
import BU_Q4_24_25 from '../assests/aboutImages/BusinessUpdate/Q4 FY 2024-25.pdf';
import BU_Q3_24_25 from '../assests/aboutImages/BusinessUpdate/Q3 FY 2024-25.pdf';
import BU_Q2_24_25 from '../assests/aboutImages/BusinessUpdate/Q2 FY 2024-25.pdf';

import MN_ViyashEShare from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Viyash-E-Shareholders.pdf';
import MN_ViyashUTC from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Viyash-UTC.pdf';
import MN_AppcureUTC from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Appcure-Labs-UTC.pdf';
import MN_SymedUTC from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Symed-Labs-UTC.pdf';
import MN_GeninnEShare from '../assests/aboutImages/MergerNoticesIndex/Index-and-Annexures-Geninn-E-Shareholders.pdf';
import MN_SignedSymedUTC from '../assests/aboutImages/MergerNoticesIndex/Signed-Symed-Final-UTC-Notice-28-07-2025.pdf';
import MN_SignedAppcureUTC from '../assests/aboutImages/MergerNoticesIndex/Signed-Appcure-Final-UTC-Notice-28-07-2025.pdf';
import MN_SignedViyashEGM from '../assests/aboutImages/MergerNoticesIndex/Signed-Viyash-Final-EGM-Notice-8-07-2025.pdf';
import MN_SignedViyashUTC from '../assests/aboutImages/MergerNoticesIndex/Signed-Viyash-Final-UTC-Notice-28-07-2025.pdf';
import MN_SignedGeninnEGM from '../assests/aboutImages/MergerNoticesIndex/Signed-Geninn-final-EGM-Notice-28-07-2025.pdf';


const stats = [
    { icon: <img src={marketCapImg} alt="Market Cap" />, value: "$1.2B", label: "Market Cap" },
    { icon: <img src={countriesImg} alt="Countries" />, value: "150+", label: "Countries" },
    { icon: <img src={employeesImg} alt="Employees" />, value: "3,000+", label: "Employees" },
    { icon: <img src={scientistsImg} alt="Scientists" />, value: "200+", label: "Scientists" }
];

const corporate = [
    {
        icon: <img src={corp1} alt="Board Structure" />,
        title: "Board Structure",
        desc: "Independent directors and diverse expertise"
    },
    {
        icon: <img src={corp2} alt="Committee Oversight" />,
        title: "Committee Oversight",
        desc: "Audit, Risk, and Remuneration committees"
    },
    {
        icon: <img src={corp3} alt="Risk Management" />,
        title: "Risk Management",
        desc: "Comprehensive enterprise risk framework"
    },
    {
        icon: <img src={corp4} alt="Compliance Framework" />,
        title: "Compliance Framework",
        desc: "Robust policies and monitoring systems"
    }
];

const ethics = [
    {
        icon: <img src={ethics1} alt="Code of Conduct" />,
        title: "Code of Conduct",
        desc: "Clear guidelines for ethical behavior"
    },
    {
        icon: <img src={ethics2} alt="Anti-Corruption Policy" />,
        title: "Anti-Corruption Policy",
        desc: "Zero tolerance for bribery and corruption"
    },
    {
        icon: <img src={ethics3} alt="Whistleblower Protection" />,
        title: "Whistleblower Protection",
        desc: "Safe reporting channels for concerns"
    },
    {
        icon: <img src={ethics4} alt="Data Privacy" />,
        title: "Data Privacy",
        desc: "GDPR and data protection compliance"
    }
];

const ArrowRightIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"></line>
        <polyline points="12 5 19 12 12 19"></polyline>
    </svg>
);

const businessUpdates = [
    { title: "Q3 FY 2025-26", file: BU_Q3_25_26 },
    { title: "Q2 FY 2025-26", file: BU_Q2_25_26 },
    { title: "Q1 FY 2025-26", file: BU_Q1_25_26 },
    { title: "Q4 FY 2024-25", file: BU_Q4_24_25 },
    { title: "Q3 FY 2024-25", file: BU_Q3_24_25 },
    { title: "Q2 FY 2024-25", file: BU_Q2_24_25 },
];

const mergerNotices = [
    { title: "Index and Annexures - Viyash E Shareholders", file: MN_ViyashEShare },
    { title: "Index and Annexures - Viyash UTC", file: MN_ViyashUTC },
    { title: "Index and Annexures - Appcure Labs UTC", file: MN_AppcureUTC },
    { title: "Index and Annexures - Symed Labs UTC", file: MN_SymedUTC },
    { title: "Index and Annexures - Geninn E Shareholders", file: MN_GeninnEShare },
    { title: "Signed Symed Final UTC Notice - 28 07 2025", file: MN_SignedSymedUTC },
    { title: "Signed Appcure Final UTC Notice - 28 07 2025", file: MN_SignedAppcureUTC },
    { title: "Signed Viyash Final EGM Notice - 28 07 2025", file: MN_SignedViyashEGM },
    { title: "Signed Viyash Final UTC Notice - 28 07 2025", file: MN_SignedViyashUTC },
    { title: "Signed Geninn final EGM Notice - 28 07 2025", file: MN_SignedGeninnEGM },
];

const timelineHuman = [
    {
        icon: <img src={humanFlagImg} alt="Flag" style={{ color: "#4A5565", fontSize: "14px" }} />,
        date: "Feb 2019",
        text: "Founded by Dr. Hari Babu Bodepudi (former Global COO of Mylan)."
    },
    {
        icon: <img src={humanBuildingImg} alt="Building" />,
        date: "Late 2019",
        text: "Rapidly built capacity by acquiring controlling stakes in Vindhya Pharma and Vandana Life Sciences."
    },
    {
        icon: <img src={humanGlobeImg} alt="Globe" />,
        date: "May 2021",
        text: "Acquired Mylan’s API and Formulations units in Vizag and Mumbai."
    },
    {
        icon: <img src={humanArrowImg} alt="Arrow" />,
        date: "Nov 2021",
        text: "Investment by Carlyle group"
    },
    {
        icon: <img src={humanCircleImg} alt="Circle" />,
        date: "July 2021",
        text: "Acquired Symed Labs, a leader in niche APIs with multiple USFDA-approved sites."
    },
    {
        icon: <img src={humanRocketImg} alt="Rocket" />,
        date: "July 2021",
        text: "US expansion by acquiring a majority stake in Appco Pharma LLC (New Jersey-based generic formulations)"
    }
];

const animalTimeline = [
    {
        icon: <img src={animalFlagImg} alt="Flag" />,
        date: "1985",
        text: "Incorporated as Visistha Trades & Finance."
    },
    {
        icon: <img src={animalBuildingImg} alt="Building" />,
        date: "2004",
        text: "Incorporated as Visistha Trades & Finance."
    },
    {
        icon: <img src={animalGlobeImg} alt="Globe" />,
        date: "2009",
        text: "Rebranded as SeQuent Scientific Limited."
    },
    {
        icon: <img src={animalArrowImg} alt="Arrow" />,
        date: "2014",
        text: "Consolidated Animal Health under the Alivira brand."
    },
    {
        icon: <img src={animalCircleImg} alt="Circle" />,
        date: "2015",
        text: "Listed on NSE; Achieved India’s first USFDA Veterinary API approval."
    },
    {
        icon: <img src={animalRocketImg} alt="Rocket" />,
        date: "2016-18",
        text: "Global expansion via acquisitions in Spain, Brazil, Turkey, and Germany."
    }
];

const boardOfDirectors = [
    { image: kamalImg, name: "Dr. Kamal Sharma", role: "Chairman & Independent Director", description: "Dr. Kamal Sharma has over 48 years of professional experience in executive positions in the Chemical and Pharmaceutical industries and has essayed a wide variety of roles in operations, corporate development and executive management. As the Managing Director of Lupin for a decade between 2003-13, he was instrumental in Lupin achieving leadership position in key markets and businesses, transforming it into one of the largest and fastest growing pharmaceutical companies globally. Previously, he also served as President & Chief Executive of the Life Sciences and speciality group and Member of the Management Board at RPG Enterprises. Mr. Sharma received a Bachelors Degree in Chemical Engineering from IIT Kanpur, a post graduate diploma in Industrial Management from Jamnalal Bajaj Institute of Management Studies and a PhD in Economics from IIT, Mumbai. He has also attended Advanced Management Program (AMP) at Harvard Business School, Boston." },
    { image: haribabuImg, name: "Dr. Haribabu Bodepudi", role: "Managing Director & Group CEO", description: "Dr. Haribabu holds a PhD in Organic Chemistry and has over 30 years of experience in the global pharmaceutical industry. He has held various leadership roles in multinational companies and has extensive expertise in pharmaceutical development, regulatory strategy, global supply chain management, and commercial operations. His strategic leadership has fostered innovation, operational excellence, and expansion into global markets." },
    { image: rajaramImg, name: "Mr. Rajaram Narayanan", role: "Executive Director and CEO – Animal Health", description: "With over 25 years of experience, Mr. Narayanan has a strong track record of leading revenue and profitability growth across multiple industries including pharmaceuticals. He joins from Sanofi India Limited, where he was the Managing Director and Country Chair for India. At Sanofi, he led the strategic reorientation of its India business operations, resulting in accelerated growth in key therapies and significant transformation of Sanofi’s market operations. Before this, he was Chief Marketing Officer at Airtel, India’s leading telecommunications company. Mr. Narayanan started his career at Hindustan Unilever Ltd., where he held various leadership roles in India and other Asian markets for over 18 years, building and managing many iconic consumer brands. Mr. Narayanan holds a Degree of BE (Hons)-Electrical & Electronics from Birla Institute of Technology and Science, Pilani, and MBA from Indian Institute of Foreign Trade, New Delhi. He has completed the Advanced Management Program from Harvard Business School, USA." },
    { image: executiveD, name: "Mr. Srinivas Vasireddy", role: "Executive Director", description: "Mr. Srinivas Vasireddy brings 37 years of extensive experience across all facets of API operations. His expertise spans Manufacturing, PPIC, Third-Party Manufacturing, and driving improvements in Quality, Compliance, and EHS standards. Prior to joining the Company, he served as Head of API (Special Projects) at Mylan Laboratories, where he played a key role in managing critical projects and ensuring operational excellence. His career reflects a strong focus on optimizing processes, enhancing compliance, and delivering sustainable improvements across API operations. He holds a B.Sc. degree from Nagarjuna University." },
    { image: anujImg, name: "Mr. Anuj Poddar", role: "Non-Executive Director", description: "Anuj Poddar is a Managing Director and Asia Co-Head of Global Portfolio Solutions at Carlyle, the leading global investment firm with USD 465 billion of assets under management. In his role, Mr. Poddar works closely with Carlyle Asia’s investment advisory teams to oversee value creation strategies and to help drive transformational change and performance with portfolio companies, focusing on India, Australia and South-East Asia. Prior to this, he was the Managing Director and Chief Executive Officer of Bajaj Electricals, India’s leading Consumer Products and Lighting Solutions company (with an erstwhile Power EPC business which was spun off). He is credited with having driven transformation of the company in a relatively short period, that resulted in significant turnaround of performance and value creation for all stakeholders. Prior to Bajaj Electricals, he was a member of the Leadership Team at Viacom18 Media and one of its key founding team members. During his over 13 years with the company he played an integral role in the growth of the company He also led strategy for MTV Networks Asia, based out of Singapore. Prior to Viacom18 Media, Anuj spent nearly a decade with Arthur Andersen and KPMG and was involved in a range of consulting, mergers & acquisitions and assurance services to varied clients across sectors. He is an Aspen Fellow, Trustee of the Ananta Centre, member of various committees of CII (Confederation of Indian Industry), member of The Trilateral Commission and a member of BMW Foundation’s World Responsible Leaders’ Network. Anuj is a rank-holding Chartered Accountant and lives in Mumbai, India." },
    //{ image: fabianImg, name: "Dr. Fabian Kausche", role: "Non Executive Director", description: "Dr. Kausche is a Chairman of the Board of PetMedix, Cambridge. Dr. Kausche also owns and runs FK Consulting, LLC, Atlanta. He has several decades of experience in the animal and human health industries in both biological and pharmaceutical research and development. He held subsequent positions as Global Head of R&D for Novartis Animal Health, Merial, and Boehringer Ingelheim Animal Health. Worked in the human health space as head of R&D for Novartis Consumer Health. Prior to that, he also successfully led a companion animal sales force for Novartis Animal Health. Dr. Kausche received a veterinary degree from the Hannover Veterinary School. He subsequently completed a Master’s of Science degree at Iowa State University. Following the completion of the M.S. degree, Having completed the Advanced Management Program in 2005, he is also an alumnus of Harvard Business School." },
    //{ image: greogoryImg, name: "Mr. Gregory Andrews", role: "Non-executive Director", description: "Greg is a multi-disciplinary executive with 30 years of commercial experience in the pharmaceutical industry. He is a dynamic business leader who creates a positive impact on the business environment through change and active engagement of both internal and external stakeholders. Currently Greg is a global animal health consultant with offices in the USA and France. He previously held executive positions within three of the major animal health companies where he gained global experience living and working in Australia, Belgium, France and the USA. Marketing, communications and management are core disciplines for Greg. He has led many marketing teams in the USA and Europe and most recently was the Global Marketing Director for Virbac. Greg headed global Public Affairs and Policy for Pfizer Animal Health during its IPO transition to Zoetis. He has also held numerous senior management roles including country management for Belgium and the Netherlands and was Vice President for emerging markets in Europe, Africa, Middle East, Russia and CIS. Greg received a Bachelor of Science (Hons) from Monash University, Australia and Post Graduate Diplomas in both Business Management and International Relations from the University of Tasmania, Australia." },
    { image: milindImg, name: "Mr. Milind Sarwate", role: "Independent Director", description: "Milind Sarwate is the Founder & CEO of Increate Value Advisors LLP. “Increate” means “Uncreated” or “Undiscovered”. Milind set up Increate in 2015 as his second career as an entrepreneur, to help organizations & individuals discover, develop & deliver business & social value. For this, he contributes as required- as Advisor, Mentor, Board Member, or Investor, leveraging his 37-year experience including long stints in Marico & Godrej. His Advisory roles in Business Value Creation encompass the following. His Directorships include 5 listed companies- Mahindra Finance, Hexaware, Glenmark, Metropolis, Matrimony.com- and 3 unlisted companies- OmniActive Health Technologies, Eternis Fine Chemicals and WheelsEMI, all with focus on the audit committee. He also plays Advisory Board role in Bruhat Insights Global, a start up in Artificial Intelligence in HR, and Educo, a School Support NGO. He invests in promising business/ social enterprises (largely SMEs), by way of venture and angel capital. He has been awarded ICAI CFO Award (2011), CNBC TV-18 CFO Award (2012) & CFO India Hall of Fame induction (2013). Milind is a Chartered Accountant, Cost Accountant, Company Secretary and Commerce Graduate. He is a CII-Fulbright Fellow (Carnegie Mellon University, U S A)." },
    { image: revatiImg, name: "Ms. Revati Kasture", role: "Independent Director", description: "Revati Kasture has over two decades of experience in ratings and research. She is currently the Executive Director (under organization nomenclature) of Care Ratings Limited and CEO of CareEdge Global IFSC Limited (CGIL), a wholly owned subsidiary of Care Ratings. Prior to this she was heading the Criteria and Policy Department at CARE Ratings which entailed development of rating criteria, policy and rating models, process improvements as well as interacting with regulators. In the span of her career, she has managed multiple departments within CARE including the large corporate ratings, incubation and scale-up of industry research department making it a profit Centre." },

];

const leadershipTeam = [
    { img: haribabuImg, name: "Dr. Haribabu Bodepudi", role: "Managing Director & Group CEO", description: "Dr. Haribabu holds a PhD in Organic Chemistry and has over 30 years of experience in the global pharmaceutical industry. He has held various leadership roles in multinational companies and has extensive expertise in pharmaceutical development, regulatory strategy, global supply chain management, and commercial operations. His strategic leadership has fostered innovation, operational excellence, and expansion into global markets." },
    { img: rajaramImg, name: "Mr. Rajaram Narayanan", role: "Executive Director and CEO – Animal Health", description: "With over 25 years of experience, Mr. Narayanan has a strong track record of leading revenue and profitability growth across multiple industries including pharmaceuticals. He joins from Sanofi India Limited, where he was the Managing Director and Country Chair for India. At Sanofi, he led the strategic reorientation of its India business operations, resulting in accelerated growth in key therapies and significant transformation of Sanofi’s market operations. Before this, he was Chief Marketing Officer at Airtel, India’s leading telecommunications company. Mr. Narayanan started his career at Hindustan Unilever Ltd., where he held various leadership roles in India and other Asian markets for over 18 years, building and managing many iconic consumer brands. Mr. Narayanan holds a Degree of BE (Hons)-Electrical & Electronics from Birla Institute of Technology and Science, Pilani, and MBA from Indian Institute of Foreign Trade, New Delhi. He has completed the Advanced Management Program from Harvard Business School, USA." },

    {
        name: "Mr. Ramakant Singani",
        role: "Chief Financial Officer",
        img: ramakantImg,
        description: "~27 years of experience across all aspects of finance including Budgeting, MIS, ERP implementation and cost management. Prior to Viyash, was Head of GMO Finance for Dr. Reddy’s"
    },
    {
        name: "Mr. Vasireddy Srinivas",
        role: "SVP & Head - API Operations",
        img: vasi,
        description: "Mr. Srinivas Vasireddy brings 37 years of extensive experience across all facets of API operations. His expertise spans Manufacturing, PPIC, Third-Party Manufacturing, and driving improvements in Quality, Compliance, and EHS standards. Prior to joining the Company, he served as Head of API (Special Projects) at Mylan Laboratories, where he played a key role in managing critical projects and ensuring operational excellence. His career reflects a strong focus on optimizing processes, enhancing compliance, and delivering sustainable improvements across API operations. He holds a B.Sc. degree from Nagarjuna University."
    },
    // {
    //     name: "Mr. Rajkamal Varshney",
    //     role: "SVP & Head – API Sales",
    //     img: rajkamalImg,
    //     description: "Mr. Rajkamal Varshney did his B Tech in Chemical Technology from HBTI, Kanpur and Sr. Management Program from IIM, Calcutta. He has 30 Years of experience having core competencies in New Business Development and Growth, Strategic Relationship Management, New Market Development and Key Accounts Management. Before joining Viyash, Mr. Rajkamal Varshney was associated with Biocon Limited, as Regional Head of API Sales & BD."
    // },


    {
        name: "Mr. Alexis Goux",
        role: "Head - Global Formulations",
        img: Alexis,
        description: ""
    },


    // Rajkamal🡪 Head of Global Formulation
    //  Alexis 🡪 Ramon Ramon 🡪 Murat 🡪Yawar 🡪 Alivira HR Prasad before Srinivas.


    {
        name: "Mr. Ramon Vila",
        role: "Europe Operations",
        img: RamonVila,
        description: ""
    },
    // {
    //     name: "Mr. Alan Kelly",
    //     role: "United States Operations",
    //     img: Alan,
    //     description: ""
    // },
    // {
    //     name: "Mr. Murat Mentes",
    //     role: "Turkey Operations",
    //     img: MuratMentes,
    //     description: ""
    // },
    // {
    //     name: "Mr. Yawar Abbas",
    //     role: "Emerging Markets",
    //     img: YawarAbbas,
    //     description: ""
    // },


    // {
    //     name: "Dr. Pramod Kumar",
    //     role: "SVP & Head - API R&D",
    //     img: pramodImg,
    //     description: "Dr. Pramod Kumar has done is Masters in Organic Chemistry from Lucknow University and Ph.D. from I.I.T. Kanpur. He has over 28 years of research experience in Chemical Research & Development in companies like Lupin Laboratories Ltd, Ranbaxy Research Laboratories, Jubilant Life Sciences Ltd & Micro Labs Ltd. Before joining Viyash, Dr. Pramod Kumar was associated with Micro Labs Limited as Vice President – API R&D. He has about 50 patents in his name filed in India, Europe and US. Published around 30 national and international journals on different areas of Synthetic Organic Chemistry."
    // },
    // {
    //     name: "Dr. AJ Reddy",
    //     role: "Head – SCM",
    //     img: aj,
    //     description: "Over 3 decades of experience in SCM, Inventory management and Logistics Expert at implementing analytics-based processes for transformation Prior to Viyash, held key positions in Hetero, Mylan, Neuland, Dr. Reddy’s and Sri Krishna Pharma"
    // },
    {
        name: "Mr. Samson Ponselvan",
        role: "Head – EHS",
        img: samsonImg,
        description: "~24 years of experience across EHS operations, Risk Management, Audit and Training across diverse sectors Experienced in international best practices and sustainability initiatives in both API and Formulations operations Served as Regional EHS Head for TAPI Asia."
    },
    // {
    //     name: "Mr. M Srinivas",
    //     role: "Head - HR",
    //     img: srinivasImg,
    //     description: "20 years of experience in the area of strategic human resources management, employee engagement, change management and organizational development Previously worked for GVK Bio, SAB Miller India and Lafarge India"
    // },
    // {
    //     name: "Mr. Prasad Lad",
    //     role: "Human Resources",
    //     img: MrPrasadLad,
    //     description: ""
    // },
    // {
    //     name: "Ms. Janaki S",
    //     role: "Head – Legal and Secretarial",
    //     img: janakiImg,
    //     description: "Over 15 years of experience in legal, secretarial and insurance. Previously, worked with Laurus Labs and served as KMP for one of it’s group companies"
    // },

    // {
    //     name: "Mr. Kiran Varma",
    //     role: "Head - Information Technology",
    //     img: kiranImg,
    //     description: "~20 years of diverse experience with competencies in IT Infra, Security, Applications, ERP, Enterprise Architect and Compliance for Healthcare companies. Have served as Director – IT for companies like Wipro, Emerson and Dr. Reddy’s."
    // }
];

const HomeIcon = () => (
    <svg className="about-breadcrumb-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M10 14V8.66667C10 8.48986 9.92976 8.32029 9.80474 8.19526C9.67971 8.07024 9.51014 8 9.33333 8H6.66667C6.48986 8 6.32029 8.07024 6.19526 8.19526C6.07024 8.32029 6 8.48986 6 8.66667V14" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2 6.66667C1.99995 6.47271 2.04222 6.28108 2.12386 6.10514C2.20549 5.92921 2.32453 5.7732 2.47267 5.648L7.13933 1.64867C7.37999 1.44527 7.6849 1.33368 8 1.33368C8.3151 1.33368 8.62001 1.44527 8.86067 1.64867L13.5273 5.648C13.6755 5.7732 13.7945 5.92921 13.8761 6.10514C13.9578 6.28108 14 6.47271 14 6.66667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V6.66667Z" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export function useScrollAnimation() {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const element = ref.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.unobserve(element);
                }
            },
            { threshold: 0.2 }
        );

        if (element) observer.observe(element);

        return () => observer.disconnect();
    }, []);

    return [ref, visible];
}


// Custom hook for counter animation
function useCounter(target, duration = 1500) {
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !started.current) {
                    started.current = true;
                    const start = performance.now();
                    const tick = (now) => {
                        const elapsed = now - start;
                        const progress = Math.min(elapsed / duration, 1);
                        setCount(Math.floor(progress * target));
                        if (progress < 1) requestAnimationFrame(tick);
                        else setCount(target);
                    };
                    requestAnimationFrame(tick);
                }
            },
            { threshold: 0.3 }
        );
        observer.observe(node);
        return () => observer.disconnect();
    }, [target, duration]);

    return { count, ref };
}

// Flexible animated counter — handles "$1.2B", "60+", "5,000+", etc.
function AnimatedCounter({ value, className }) {
    // Match: optional prefix (non-digit), digits, optional suffix (rest)
    const match = value.match(/^([^0-9]*)(\d+(?:\.\d+)?)(.*)$/);
    const prefix = match ? match[1] : '';
    const numeric = match ? parseFloat(match[2].replace(/,/g, '')) : 0;
    const suffix = match ? match[3] : value;
    const isFloat = String(match?.[2]).includes('.');
    const { count, ref } = useCounter(numeric, 1800);

    return (
        <span ref={ref} className={className}>
            {prefix}{isFloat ? count.toFixed(1) : Math.floor(count).toLocaleString()}{suffix}
        </span>
    );
}

const ScrollingTimeline = ({ items, itemClass, iconClass, dateClass, cardClass, lineClass }) => {
    const trackRef = useRef(null);
    const speedRef = useRef(1); // Target speed
    const currentSpeedRef = useRef(1);
    const positionRef = useRef(0);
    const requestRef = useRef();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isMobile) {
            if (requestRef.current) cancelAnimationFrame(requestRef.current);
            if (trackRef.current) trackRef.current.style.transform = 'none';
            return;
        }

        const animate = () => {
            // Deceleration/Acceleration logic
            currentSpeedRef.current += (speedRef.current - currentSpeedRef.current) * 0.05;

            if (trackRef.current) {
                positionRef.current -= currentSpeedRef.current;

                // Track width is exactly twice the set width
                const trackWidth = trackRef.current.scrollWidth;
                const setWidth = trackWidth / 2;

                if (positionRef.current <= -setWidth) {
                    positionRef.current += setWidth;
                }
                trackRef.current.style.transform = `translateX(${positionRef.current}px)`;
            }
            requestRef.current = requestAnimationFrame(animate);
        };

        requestRef.current = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(requestRef.current);
    }, [isMobile]);

    const handleMouseEnter = () => { if (!isMobile) speedRef.current = 0; };
    const handleMouseLeave = () => { if (!isMobile) speedRef.current = 1; };

    // Common set of items to repeat
    const renderSet = () => (
        <div className="about-timeline-set" style={{ paddingRight: "40px" }}>
            {items.map((item, i) => (
                <div key={i} className={itemClass}>
                    <div className={iconClass}>
                        {item.icon}
                    </div>
                    <span className={dateClass}>{item.date}</span>
                    <div className={cardClass} >
                        {item.text}
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <div
            className="about-timeline-wrapper"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ cursor: isMobile ? 'default' : 'pointer' }}
        >
            <div
                className="about-timeline-track"
                ref={trackRef}
                style={{ animation: 'none', display: 'flex', gap: '0' }}
            >
                <div className={lineClass}></div>
                {renderSet()}
                {!isMobile && renderSet()}
            </div>
        </div>
    );
};

const About = () => {
    const [activeTab, setActiveTab] = useState("board")
    const [selectedLeader, setSelectedLeader] = useState(null);

    const leadershipData = activeTab === "board" ? boardOfDirectors : leadershipTeam

    const [ref1, visible1] = useScrollAnimation();
    const [ref2, visible2] = useScrollAnimation();
    const [ref3, visible3] = useScrollAnimation();
    const [ref4, visible4] = useScrollAnimation();
    const [ref5, visible5] = useScrollAnimation();
    const [ref6, visible6] = useScrollAnimation();
    const [ref7, visible7] = useScrollAnimation();

    return (
        <div className="about-page">
            <section className="about-hero-section">
                <div className="about-hero-overlay"></div>
                <div className="about-hero-content">
                    <h1 className="about-hero-title">
                        Advancing <span style={{ color: '#f7931e', fontStyle: 'italic' }}>Global Health</span> through <br />Pharmaceutical Excellence

                    </h1>
                </div>
            </section>

            <div className="about-breadcrumb-container">
                <div className="about-breadcrumb-wrapper">
                    <Link to="/" className="about-breadcrumb-link about-home-link">
                        <HomeIcon /> Home
                    </Link>
                    <span className="about-breadcrumb-separator" style={{ padding: "10px" }}>›</span>
                    <span className="about-breadcrumb-current">About Viyash</span>
                </div>
            </div>

            <section ref={ref1} className={`about-overview-section reveal reveal-up ${visible1 ? "reveal-visible" : ""}`}>
                <div className="wrapper">
                    <div className="about-overview-container">
                        <h2 className="about-overview-title fontSize-38">Overview & Vision</h2>
                        <div className="about-section-divider">
                            <span className="about-line left"></span>
                            <div className="about-icon-circle">
                                <img src={minLogo} style={{ width: "28px", height: "22px" }} alt="company overview" />
                            </div>
                            <span className="about-line right"></span>
                        </div>
                        <p className="about-overview-subtitle" style={{ marginBottom: "50px", fontSize: "20px" }}>Our Identity. Our Direction.</p>




                        <div className="about-overview-grid-2">
                            <div className="about-overview-grid-2-1"><img src={overviewImg} alt="company overview" /></div>
                            <div className="about-overview-grid-2-2">
                                <div className="about-overview-card">
                                    <h3>Company Overview</h3>
                                    <p>
                                        Viyash Scientific, rooted in the Vedic values of honesty and leadership, is an integrated global pharmaceutical company bringing together the strengths of Viyash and SeQuent across human and animal health (Alivira).</p>
                                    <p>We offer a comprehensive portfolio of APls, advanced intermediates, and formulations, supported by large-scale manufacturing to serve global healthcare needs. Our operations include 10 API/intermediate facilities (~2,300 KL+ capacity) and 5 formulation plants across geographies, with a presence in 150+ countries.</p>
                                    <p>As a dynamic and adaptable organization, we leverage deep industry expertise and a broad global reach. Our commitment to trust, quality, cost efficiency, and long-term value remains central to how we serve our customers and stakeholders.
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div className="about-overview-grid-3">
                            <div className="about-overview-grid-3-1"> <div className="about-vision-card-2">
                                <div className="about-card-header-2">
                                    <div className="about-icon-wrapper-2">
                                        <img src={visionImg} alt="Our Vision" />
                                    </div>
                                    <h3>Our Vision</h3>
                                </div>
                                <p>
                                    To be a world class recognised pharmaceutical leader, trusted globally for  pharma products in quality, innovation, integrity and compliance across human and animal health.
                                </p>
                            </div></div>
                            <div className="about-overview-grid-3-1"> <div className="about-mission-card-2">
                                <div className="about-card-header-2">
                                    <div className="about-icon-wrapper-2">
                                        <img src={missionImg} alt="Our Mission" />
                                    </div>
                                    <h3>Our Mission</h3>
                                </div>
                                <p>
                                    To improve human and animal lives by making high-quality, affordable products accessible through science, scale, and trusted partnerships.
                                </p>
                            </div></div>
                        </div>



                        {/* <div className="about-overview-grid">
                            <div className={`about-overview-left reveal reveal-left ${visible1 ? "reveal-visible" : ""}`}>
                                <img src={overviewImg} alt="company overview" />
                                <div className="about-overview-card">
                                    <h3>Company Overview</h3>
                                    <p>
                                        Viyash Scientific - rooted in the Vedic values of honesty and leadership - is an integrated global pharmaceutical company that brings together the strengths of Viyash and SeQuent across human and animal health(Alivira). </p>
                                    <p> We combine a strong portfolio of  APIs/advanced intermediates and formulations with manufacturing scale to serve global healthcare needs. Our operations span 10 API/intermediate facilities (~2,300 KL+ capacity), 5 formulation plants across geographies, and a business present in 150+ countries.</p>
                                    <p> As a dynamic and adaptable organization, we leverage deep industry expertise and a broad global reach. Our steadfast commitment to trust, quality, cost efficiency, and the delivery of long-term value is fundamental to our approach in serving our customers and stakeholders.
                                    </p>
                                </div>
                            </div>


                            <div className={`about-overview-right reveal reveal-right ${visible1 ? "reveal-visible" : ""}`}>
                                <div className="about-vision-card">
                                    <div className="about-card-header">
                                        <div className="about-icon-wrapper">
                                            <img src={visionImg} alt="Our Vision" />
                                        </div>
                                        <h3>Our Vision</h3>
                                    </div>
                                    <p>
                                        To be a world class recognised pharmaceutical leader, trusted globally for  pharma products in quality, innovation, integrity and compliance across human and animal health.
                                    </p>
                                </div>

                                <div className="about-mission-card">
                                    <div className="about-card-header">
                                        <div className="about-icon-wrapper">
                                            <img src={missionImg} alt="Our Mission" />
                                        </div>
                                        <h3>Our Mission</h3>
                                    </div>
                                    <p>
                                        To improve human and animal lives by making high-quality, affordable products accessible through science, scale, and trusted partnerships.
                                    </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>

            {/* ref={ref4} className={`about-company-section reveal reveal-up ${visible4 ? "reveal-visible" : ""}`} */}
            <section id="leadership-section" ref={ref4} >
                <div className="wrapper">
                    <div className="about-leadership">
                        <h2 className="fontSize-38 m-t-70">Leadership & Management</h2>
                        <div className="about-section-divider">
                            <span className="about-line left"></span>
                            <div className="about-icon-circle">
                                <img src={minLogo} style={{ width: "28px", height: "22px" }} alt="company overview" />
                            </div>
                            <span className="about-line right"></span>
                        </div>
                        <p className="about-subtitle">Experienced leaders driving our success</p>

                        <div className="about-tabs-wrapper">
                            <button
                                className={activeTab === "board" ? "about-tab active" : "about-tab"}
                                onClick={() => setActiveTab("board")}
                            >
                                Board of Directors
                            </button>
                            <button
                                className={activeTab === "team" ? "about-tab active" : "about-tab"}
                                onClick={() => setActiveTab("team")}
                            >
                                Leadership Team
                            </button>
                        </div>

                        <div className="about-leadership-grid">
                            {leadershipData.map((person, i) => (
                                <div
                                    key={i}
                                    className={`about-leader-card reveal reveal-up ${visible4 ? "reveal-visible" : ""}`}
                                    onClick={() => setSelectedLeader(person)}
                                    style={{ transitionDelay: `${i * 0.05}s` }}
                                >
                                    <img
                                        src={person.image || person.img}
                                        alt={person.name}
                                    />

                                    <div className="leaderNameAndRole">
                                        <h4 className="leaderName">{person.name}</h4>
                                        <p className="leaderRole">{person.role}</p>
                                    </div>

                                    <div className="about-arrow">
                                        <img src={arrows} alt="arrow" />
                                    </div>
                                </div>
                            ))}
                        </div>
                        {selectedLeader && (
                            <div className="leader-modal-overlay" onClick={() => setSelectedLeader(null)}>

                                <div
                                    className="leader-modal"
                                    onClick={(e) => e.stopPropagation()}
                                >

                                    <button
                                        className="leader-close"
                                        onClick={() => setSelectedLeader(null)}
                                    >
                                        ✕
                                    </button>

                                    <img
                                        src={selectedLeader.image || selectedLeader.img}
                                        className="leader-modal-image"
                                        alt={selectedLeader.name}
                                    />

                                    <h2 className="leader-modal-name">
                                        {selectedLeader.name}
                                    </h2>

                                    <p className="leader-modal-role">
                                        {selectedLeader.role}
                                    </p>

                                    <p className="leader-modal-description">
                                        {selectedLeader.description || "No description available."}

                                    </p>

                                </div>

                            </div>
                        )}
                    </div>
                </div>
            </section >

            <section ref={ref2} className={`about-facts-section reveal reveal-up ${visible2 ? "reveal-visible" : ""}`}>
                <div className="wrapper">
                    <h2 className="about-facts-title" style={{ marginBottom: "20px" }}>Key Facts & Figures</h2>

                    <div className="about-stats-grid">
                        {stats.map((item, index) => (
                            <div className={`about-stat-card reveal reveal-up ${visible2 ? "reveal-visible" : ""}`} key={index} style={{ transitionDelay: `${index * 0.1}s` }}>
                                <div className="about-stat-icon">{item.icon}</div>
                                <div>
                                    <h3>
                                        <AnimatedCounter value={item.value} />
                                    </h3>
                                    <p>{item.label}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="about-info-grid">
                        <div className={`about-info-card reveal reveal-left ${visible2 ? "reveal-visible" : ""}`}>
                            <div className="about-info-header">
                                <div className="about-info-icon-wrap">
                                    <img src={innovationImg} alt="Innovation" style={{ width: "32px", height: "32px" }} />
                                </div>
                                <span>Innovation</span>
                            </div>
                            <p>
                                A powerful R&D ecosystem that develops complex molecules and next-generation pharmaceutical solutions to address unmet healthcare needs.
                            </p>
                        </div>

                        <div className={`about-info-card reveal reveal-up ${visible2 ? "reveal-visible" : ""}`}>
                            <div className="about-info-header">
                                <div className="about-info-icon-wrap">
                                    <img src={qualityImg} alt="Quality Excellence" style={{ width: "32px", height: "32px" }} />
                                </div>
                                <span>Quality Excellence</span>
                            </div>
                            <p>
                                Rigorous adherence to global regulatory standards and an unwavering focus on compliance ensure consistent, world-class product quality.
                            </p>
                        </div>

                        <div className={`about-info-card reveal reveal-right ${visible2 ? "reveal-visible" : ""}`}>
                            <div className="about-info-header">
                                <div className="about-info-icon-wrap">
                                    <img src={growthImg} alt="Global Growth" style={{ width: "32px", height: "32px" }} />
                                </div>
                                <span>Global Growth</span>
                            </div>
                            <p>
                                A diversified international footprint, reinforced by strategic acquisitions and partnerships, positions the company for sustainable long-term growth.
                            </p>
                        </div>
                    </div>
                </div>
            </section>


            {/* className={`about-scroll-section reveal reveal-up ${visible3 ? "reveal-visible" : ""}`} style={{ justifyContent: "center", backgroundColor: "#fafbfb" }} */}
            <section ref={ref3} >
                <div className="about-history" >
                    <h2 className="fontSize-38">History & Evolution</h2>
                    <div className="about-section-divider">
                        <span className="about-line left"></span>
                        <div className="about-icon-circle">
                            <img src={minLogo} style={{ width: "28px" }} alt="company overview" />
                        </div>
                        <span className="about-line right"></span>
                    </div>

                    {/* <p className="about-subtitle" style={{ fontSize: "20px", height: "50px" }}>Our journey and acquisition milestones</p>

                    <h4 style={{ textAlign: "center", fontSize: "24px" }}>Human Health</h4>

                    <ScrollingTimeline
                        items={timelineHuman}
                        itemClass="about-timeline-item"
                        iconClass="about-timeline-icon"
                        dateClass="about-timeline-date"
                        cardClass="about-timeline-card"
                        lineClass="timeline-moving-line human-line"
                    /> */}
                </div>


                {/* <div className="about-history">
                    <h4 style={{ textAlign: "center", fontSize: "24px" }}>Animal Health</h4>
                    <ScrollingTimeline
                        items={animalTimeline}
                        itemClass="about-timeline1-item"
                        iconClass="about-timeline1-icon"
                        dateClass="about-timeline1-date"
                        cardClass="about-timeline1-card"
                        lineClass="timeline-moving-line animal-line"
                    />
                </div> */}
            </section>

            <div className="timeline-bg">
                <div className="wrapper-2 ">
                    <img src={desktopImg} alt="desktop" className="desktop-img-display" />
                    <img src={mobileImg} alt="mobile" className="mobile-img-display" />
                </div>
            </div>
            <section ref={ref5} className={`about-strategy-section reveal reveal-up ${visible5 ? "reveal-visible" : ""}`}>
                <div className="about-strategy-grid">
                    <div className={`about-strategy-card reveal reveal-left ${visible5 ? "reveal-visible" : ""}`}>
                        <div className="about-strategy-header">
                            <img src={strategyImg} alt="Strategic Planning" style={{ width: "42px", height: "42px" }} />
                            <h4>Strategic Planning</h4>
                        </div>
                        <div className="about-strategy-body">
                            <p>Long-term vision with agile execution and data-driven decision making</p>
                        </div>
                    </div>

                    <div className={`about-strategy-card reveal reveal-up ${visible5 ? "reveal-visible" : ""}`}>
                        <div className="about-strategy-header">
                            <img src={operationalImg} alt="Operational Excellence" style={{ width: "42px", height: "42px" }} />
                            <h4>Operational Excellence</h4>
                        </div>
                        <div className="about-strategy-body">
                            <p>Continuous improvement and lean manufacturing principles</p>
                        </div>
                    </div>

                    <div className={`about-strategy-card reveal reveal-right ${visible5 ? "reveal-visible" : ""}`}>
                        <div className="about-strategy-header">
                            <img src={talentImg} alt="Talent Development" style={{ width: "42px", height: "42px" }} />
                            <h4>Talent Development</h4>
                        </div>
                        <div className="about-strategy-body">
                            <p>Investing in our people through training and career growth</p>
                        </div>
                    </div>
                </div>
            </section>
<br/><br/>
            {/* <section ref={ref6} className={`about-values-section reveal reveal-up ${visible6 ? "reveal-visible" : ""}`}>
                <h2 className="about-facts-title" style={{ marginBottom: "20px" }}>Values & Governance</h2>
                <div className="about-section-divider">
                    <span className="about-line left"></span>
                    <div className="about-icon-circle">
                        <img src={minLogo} style={{ width: "28px", height: "22px" }} alt="company overview" />
                    </div>
                    <span className="about-line right"></span>
                </div>
                <p className="about-overview-subtitle" style={{ marginBottom: "50px", fontSize: "20px", textAlign: "center" }}>Principles that guide our business</p>

                <div className="about-governance-grid">
                    <div className={`about-governance-card about-blue reveal reveal-left ${visible6 ? "reveal-visible" : ""}`}>
                        <div className="about-governance-title">
                            <img src={mainGovernanceImg} alt="Corporate Governance" />
                            <h3>Corporate Governance</h3>
                        </div>

                        {corporate.map((item, i) => (
                            <div key={i} className="about-governance-item">
                                <div className="about-gov-icon">
                                    {item.icon}
                                </div>
                                <div>
                                    <h4>{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className={`about-governance-card about-green reveal reveal-right ${visible6 ? "reveal-visible" : ""}`}>
                        <div className="about-governance-title">
                            <img src={mainEthicsImg} alt="Ethics & Compliance" />
                            <h3>Ethics & Compliance</h3>
                        </div>

                        {ethics.map((item, i) => (
                            <div key={i} className="about-governance-item">
                                <div className="about-gov-icon">
                                    {item.icon}
                                </div>
                                <div>
                                    <h4>{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}

            {/* <section ref={ref7} className={`about-values-section reveal reveal-up ${visible7 ? "reveal-visible" : ""}`}>
                <h2 className="about-facts-title" style={{ marginBottom: "20px" }}>Business Updates & Merger Notices</h2>
                <div className="about-section-divider">
                    <span className="about-line left"></span>
                    <div className="about-icon-circle">
                        <img src={minLogo} style={{ width: "28px", height: "22px" }} alt="company overview" />
                    </div>
                    <span className="about-line right"></span>
                </div>
                <p className="about-overview-subtitle" style={{ marginBottom: "50px", fontSize: "20px", textAlign: "center" }}>Latest updates and official notices</p>

                <div className="about-governance-grid">
                    <div className={`about-governance-card about-blue reveal reveal-left ${visible7 ? "reveal-visible" : ""}`}>
                        <div className="about-governance-title">
                            <h3>Business Update</h3>
                        </div>

                        {businessUpdates.map((item, i) => (
                            <a key={i} href={item.file} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div className="about-governance-item" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        <h4 style={{ margin: 0 }}>{item.title}</h4>
                                    </div>
                                    <div className="about-gov-icon" style={{ color: '#2E7D32', marginLeft: '16px' }}>
                                        <ArrowRightIcon />
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>

                    <div className={`about-governance-card about-green reveal reveal-right ${visible7 ? "reveal-visible" : ""}`}>
                        <div className="about-governance-title">
                            <h3>Merger Notices Index and Annexures</h3>
                        </div>

                        {mergerNotices.map((item, i) => (
                            <a key={i} href={item.file} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                <div className="about-governance-item" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        <h4 style={{ margin: 0 }}>{item.title}</h4>
                                    </div>
                                    <div className="about-gov-icon" style={{ color: '#2E7D32', marginLeft: '16px' }}>
                                        <ArrowRightIcon />
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </section> */}

        </div >
    );
};

export default About;
